import React from 'react';
import MentalKnowHow from './MentalKnowHow';
import withMentalPageElements, { MentalPageProps } from '../../components/MentalPageWrapper';
import LinkManager from '../../lib/LinkManager';
import MentalApi from '../../lib/MentalApi';
import { WrapperMatchParams } from '../../components/MentalPageWrapper/MentalPageWrapper';
import { MentalKnowHowMainData } from '../../types';

interface Props extends MentalPageProps<WrapperMatchParams, MentalKnowHowMainData> {
}

const MentalKnowHowWithData = ({ mentalLinkIdentifier, data }: Props) => (
    <MentalKnowHow mental={mentalLinkIdentifier} knowHowMainInfo={data} />
);

export default withMentalPageElements(MentalKnowHowWithData,
    {
        backLinkProvider: () => LinkManager.getMentalIndexLink(),
        pageLayoutProvider:
            mentalLinkIdentifier => MentalApi.getMentalKnowHowPageLayout(
                mentalLinkIdentifier.mentalId,
            ),
        dataLoader: mentalLinkIdentifier => MentalApi.getKnowHowMainData(mentalLinkIdentifier),
    });
